import { Moment, MomentInput } from 'moment';

export const disabledDateNotInclusiveDate = (current: Moment, startDate: MomentInput, endDate: MomentInput) => {
  return !current.isBetween(startDate, endDate, 'date', '[]');
};
